import { Box } from "@mui/material";

type EnvironmentBadgeVariant = "dev" | "stage";

const ENVIRONMENT_BADGE_VARIANT_BY_PUBLIC_ENV: Record<string, EnvironmentBadgeVariant> = {
  development: "dev",
  stage: "stage"
};

const ENVIRONMENT_BADGE_CONTENT: Record<EnvironmentBadgeVariant, { label: string; bgcolor: string; color: string }> = {
  dev: { label: "DEV", bgcolor: "error.dark", color: "error.contrastText" },
  stage: { label: "STG", bgcolor: "warning.dark", color: "warning.contrastText" }
};

const EnvironmentBadge = () => {
  const variant = ENVIRONMENT_BADGE_VARIANT_BY_PUBLIC_ENV[import.meta.env.VITE_PUBLIC_ENV];
  if (!variant) {
    return null;
  }

  const { label, bgcolor, color } = ENVIRONMENT_BADGE_CONTENT[variant];

  return (
    <Box
      component="span"
      aria-label={`${label} environment`}
      sx={{
        display: "inline-flex",
        alignItems: "center",
        height: 16,
        px: "4px",
        borderRadius: "4px",
        bgcolor,
        color,
        fontSize: 10,
        fontWeight: 500,
        lineHeight: "16px",
        letterSpacing: 0,
        whiteSpace: "nowrap"
      }}
    >
      {label}
    </Box>
  );
};

export default EnvironmentBadge;
